export type SchemaInfo = {
  title: string;
  description: string;
  contact?: {
    name: string;
    email: string;
  };
  version: string;
};

export type ParameterDetails = {
  name: string;
  required?: boolean;
  description: string;
  schema: {
    type: string;
    default?: unknown;
  };
};

export type RequestBodySchema = {
  $ref: string;
};

export type PathMethodDetails = {
  parameters?: ParameterDetails[];
  requestBody?: {
    content: {
      "application/json": {
        schema: RequestBodySchema;
      };
    };
  };
};

export type ApiSchema = {
  info: SchemaInfo;
  paths: Record<string, Record<string, PathMethodDetails>>;
  components: {
    schemas: Record<string, any>;
  };
};

export type ExcelFunctionParameter = {
  name: string;
  optional?: boolean;
  default?: unknown;
  description: string;
  type: string;
  schemaType?: string;
  dimensionality?: string;
  nestLevel?: number;
};

export type ExcelFunction = {
  id: string;
  name: string;
  description: string;
  parameters: ExcelFunctionParameter[];
  result: {
    type: string;
  };
  url: string;
  method: string;
  options: {
    requiresAddress: boolean;
    requiresParameterAddresses: boolean;
  };
};

export type RequestInit = {
  method: string;
  headers: Record<string, string>;
  body?: string;
  credentials?: RequestCredentials;
};

export type ApiResponse = {
  success: boolean;
  data?: any;
  error?: string;
};

export type InventoryItem = {
  name: string;
  description: string;
  path: string;
  contact: {
    name: string;
    url: string;
    email: string;
  };
};

export enum ApiMethod {
  GET = "get",
  POST = "post",
  PUT = "put",
  DELETE = "delete",
}

export const EXCEL_DIMENSIONALITY = {
  scalar: "scalar",
  matrix: "matrix",
};

export type ApiLoadingState = "idle" | "loading" | "loaded" | "error";

export type ApiEntry = {
  url: string;
  item: string | InventoryItem;
  state: ApiLoadingState;
  error: string | null;
  schemaInfo: SchemaInfo | null;
  functions: ExcelFunction[];
  registrableFunctions: ExcelFunction[];
  nonRegistrableFunctions: ExcelFunction[];
  failedEndpoints: string[];
};

export const JSON_CONTENT_TYPE = "application/json";

export const TYPE_MAPPING = {
  string: "string",
  integer: "number",
  boolean: "boolean",
};
